import { getDataOrNull } from "@msys/common";
import { CardContainer } from "@msys/ui";
import { ChatOutlined as ChatOutlinedIcon } from "@mui/icons-material";
import { useTranslate } from "@tolgee/react";
import { ClientInputsList } from "../../client-inputs/ClientInputsList.js";
import { useProjectClientInputsQuery } from "./ProjectClientInputsBox.generated.js";

interface Props {
  projectId: string;
}

export const ProjectClientInputsBox = ({ projectId }: Props) => {
  const { t } = useTranslate(["ProjectOverview", "Global"]);

  const query = useProjectClientInputsQuery({
    variables: { ownerId: projectId },
  });
  const clientInputs =
    getDataOrNull(query.data?.clientInputs)?.clientInputs ?? [];

  if (clientInputs.length === 0) return null;

  return (
    <CardContainer
      Icon={<ChatOutlinedIcon />}
      title={t("Client inputs", { ns: "ProjectOverview" })}
      isExpandable
      isInitiallyClosed={false}
    >
      <ClientInputsList clientInputs={clientInputs} />
    </CardContainer>
  );
};
